import {
  ArrowRightOutlined,
  AssignmentLateRounded,
  BusinessCenterRounded,
  DescriptionRounded,
  EmailRounded,
  LocationCityOutlined,
  ManageAccountsRounded,
  PhoneRounded,
  WorkspacePremiumRounded,
  HowToRegRounded,
  PersonAddRounded,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  tableCellClasses,
  IconButton,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { TiSocialLinkedin, TiSocialTwitter } from "react-icons/ti";
import { styled, alpha } from "@mui/material/styles";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { userSelector } from "../../user-redux/selector";
import Key from "../../../clientVariables.json";
import { myCandidatesSelector } from "../redux/selector";

const Bullet = styled("span")({
  display: "inline-block",
  width: "3px",
  height: "3px",
  borderRadius: "50%",
  backgroundColor: "currentColor",
});

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ResumeDetails = ({ resume, requiredSkills, activeJobSkills }) => {
  const [skillsOpen, setSkillsOpen] = useState(true);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [matchedSkillsList, setMatchedSkillsList] = useState([]);
  const [skillsInResume, setSkillsInResume] = useState([]);
  const [matchResumeSkills, setMatchResumeSkills] = useState([]);
  const [matchJobSkills, setMatchJobSkills] = useState([]);
  const [matchedSkillsOpen, setMatchedSkillsOpen] = useState(false);
  const [resumeFullDetails, setResumeFullDetails] = useState([]);
  const [resumeCertificationDetails, setResumeCertificationDetails] = useState(
    []
  );

  const { submissionSelectedResume, candidateDetails } =
    useSelector(myCandidatesSelector);

  const { user: currentUser } = useSelector(userSelector);

  const [resumeDetails, setResumeDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res_id = resume?.resume_id;
        if (res_id) {
          const resumeDetails = await getResumeFullDetails(res_id);
          await setResumeFullDetails(resumeDetails?.projectdetails);
          setResumeCertificationDetails(resumeDetails?.certificatedetails);
          await setResumeDetails(resumeDetails?.resumedetails);
          let skills = await resumeDetails?.resumedetails.ai_skills.split(",");
          await setSkillsInResume(skills);

          const resumeSkills =
            await resumeDetails?.resumedetails.ai_skills.split(",");
          const jobSkills = await requiredSkills;

          await setMatchResumeSkills(removeDuplicates(resumeSkills));
          await setMatchJobSkills(removeDuplicates(jobSkills));

          if (resumeSkills.length > 0 && jobSkills.length > 0) {
            const matchedSkills = await getMatchedSkills(
              resumeSkills,
              jobSkills
            );

            setMatchedSkillsList(matchedSkills);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [resume, requiredSkills]);

  const removeDuplicates = (arr) => {
    const lowerCaseSet = new Set();
    const result = [];

    arr.forEach((item) => {
      const lowerCaseItem = item.trim().toLowerCase();
      if (!lowerCaseSet.has(lowerCaseItem)) {
        lowerCaseSet.add(lowerCaseItem);
        result.push(item);
      }
    });

    return result;
  };
  const getMatchedSkills = async (resumeSkills, jobSkills) => {
    const finalResumeSkills = await removeDuplicates(resumeSkills);
    const finalJobSkills = await removeDuplicates(jobSkills);

    const matches = [];
    if (!finalResumeSkills || !finalJobSkills) {
      return matches;
    }
    finalResumeSkills.forEach((skill1) => {
      finalJobSkills.forEach((skill2) => {
        const normalSkill1 = skill1.toLowerCase();
        const normalSkill2 = skill2.toLowerCase();

        if (
          normalSkill1 === normalSkill2 ||
          normalSkill2.includes(normalSkill1) ||
          normalSkill1.includes(normalSkill2)
        ) {
          matches.push(skill1);
        }
      });
    });
    const res = await removeDuplicates(matches);
    return res;
  };

  const getResumeFullDetails = async (resumeId) => {
    try {
      const response = await axios.post(
        `${Key.domain_jnp}/resume/get_js_resume_details`,
        {
          user_id: null,
          resumeid: resumeId,
          session_token: currentUser.session_token,
        }
      );

      return response.data.data;
    } catch (error) {}
  };

  const skillBtnStyles = {
    bgcolor: skillsOpen ? "rgba(64, 104, 130, 0.9)" : "",
    color: skillsOpen ? "#fff" : "rgba(0,0,0,0.6)",
    border: skillsOpen ? "none" : "1px solid #ddd",
  };
  const workBtnStyles = {
    bgcolor: summaryOpen ? "rgba(64, 104, 130, 0.9)" : "",
    color: summaryOpen ? "#fff" : "rgba(0,0,0,0.6)",
    border: summaryOpen ? "none" : "1px solid #ddd",
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "rgba(64, 104, 130, 0.9)",
      //  theme.palette.common.black,
      color: theme.palette.common.white,
      fontSize: isDesktopLarge ? 14 : 12,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: isDesktopLarge ? 14 : 12,
    },
  }));

  return loading ? (
    <div>loading...</div>
  ) : (
    //   <ResumeProfileLoading />
    <>
      <Box
        component={Paper}
        elevation={2}
        sx={{ height: window.innerHeight, overflow: "scroll" }}
      >
        <Box sx={{ position: "relative", padding: "4px", width: "100%" }}>
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                borderLeft: "10px solid rgba(64, 104, 130, 0.8)",
                borderTop: "4px solid rgba(64, 104, 130, 0.8)",
                borderBottom: "4px solid rgba(64, 104, 130, 0.8)",
                borderRadius: "50%",
              }}
            >
              <Tooltip
                title={`Resume id: ${resume?.resume_id}`}
                arrow
                placement="top"
              >
                <Box
                  sx={{
                    borderLeft: "6px solid #fff",
                    borderTop: "3px solid #fff",
                    borderBottom: "3px solid #fff",
                    borderRadius: "50%",
                  }}
                >
                  <Avatar
                    src={
                      `${Key.domain_jnp}/dashboard/profile_image/` + resume?.uid
                    }
                    sx={{
                      height: isDesktopLarge ? "100px" : "80px",
                      width: isDesktopLarge ? "100px" : "80px",
                    }}
                  />
                </Box>
              </Tooltip>
            </Box>
          </Box>
          {resume?.home_phone !== "N/A" && (
            <Box
              sx={{
                position: "absolute",
                left: isDesktopLarge ? "115px" : null,
                right: isDesktopSmall ? "5px" : null,
                top: isDesktopSmall ? "2px" : "15px",
                ".phone-text": {
                  margin: 0,
                  fontSize: isDesktopLarge ? "11px" : "10px",
                  color: "rgba(0,0,0,0.7)",
                  fontWeight: 500,
                  cursor: "pointer",
                  textTransform: "lowercase",
                },
                "&:hover": {
                  ".phone-text": {
                    color: "#406882",
                    textDecoration: "underline",
                  },
                },
              }}
            >
              <Typography variant="button" paragraph className="phone-text">
                <PhoneRounded
                  sx={{ height: "12px", width: "12px", mr: "3px" }}
                />
                {resume?.home_phone}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              position: "absolute",
              right: "5px",
              top: "15px",
              ".email-text": {
                margin: 0,
                fontSize: isDesktopLarge ? "11px" : "10px",
                color: "rgba(0,0,0,0.7)",
                fontWeight: 500,
                cursor: "pointer",
                textTransform: "lowercase",
              },
              "&:hover": {
                ".email-text": {
                  color: "#406882",
                  textDecoration: "underline",
                },
              },
            }}
          >
            <Typography variant="button" paragraph className="email-text">
              <EmailRounded sx={{ height: "12px", width: "12px", mr: "3px" }} />
              {resume?.email_address}
            </Typography>
          </Box>
          <Paper
            elevation={1}
            sx={{
              position: "absolute",
              left: isDesktopLarge ? "105px" : "89px",
              right: 0,
              top: isDesktopLarge ? "38px" : "34px",
              padding: isDesktopLarge ? "10px" : "4px 4px 4px 6px",
              borderRadius: "6px",
              width: "auto",
              // bgcolor:'#406882',
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Tooltip
                    title={
                      <p style={{ fontSize: "10px", margin: 0 }}>
                        {resume?.full_name
                          ? resume?.full_name
                          : resume?.full_name + " " + resume?.last_name}
                      </p>
                    }
                  >
                    <Typography
                      paragraph
                      sx={{
                        margin: 0,
                        width: isDesktopLarge
                          ? "200px"
                          : isDesktopSmall
                          ? "170px"
                          : "140px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: 800,
                        color: "rgba(0,0,0,0.7)",
                        textTransform: "capitalize",
                        fontSize: isDesktopLarge ? "1.0rem" : "0.85rem",
                      }}
                    >
                      {resume?.full_name
                        ? resume?.full_name
                        : resume?.full_name + " " + resume?.last_name}
                    </Typography>
                  </Tooltip>

                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: isDesktopLarge ? "0.85rem" : "0.65rem",
                      color: "rgba(0,0,0,0.7)",
                      marginLeft: "5px",
                      marginBottom: 0,
                    }}
                  >
                    {" "}
                    #{resume?.resume_id ? resume?.resume_id : resume?.id}
                  </p>
                </Box>
              </Box>
              <Box
                sx={{
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  "&:hover": {
                    bgcolor: "#406882",
                    ".inicon": {
                      color: "#fff",
                      cursor: "pointer",
                    },
                  },
                  ".inicon": {
                    color: "#406882",
                  },
                }}
              >
                <TiSocialLinkedin
                  className="inicon"
                  style={{ height: "22px", width: "26px" }}
                />
              </Box>
            </Box>
          </Paper>
        </Box>

        {/* <Divider /> */}
        <Card sx={{ boxShadow: "none", padding: "10px" }}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Typography
                paragraph
                sx={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: isDesktopLarge ? "14px" : "12px",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                Role
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography
                paragraph
                sx={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: isDesktopLarge ? "14px" : "12px",
                  color: "rgba(0,0,0,0.9)",
                }}
              >
                {resume?.application_title}
              </Typography>
            </Grid>
          </Grid>
        </Card>
        <Divider />
        <Card sx={{ boxShadow: "none", padding: "10px" }}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Typography
                paragraph
                sx={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: isDesktopLarge ? "14px" : "12px",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                Visa Type
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography
                paragraph
                sx={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: isDesktopLarge ? "14px" : "12px",
                  color: "rgba(0,0,0,0.9)",
                }}
              >
                {resumeDetails?.visatype_name
                  ? resumeDetails?.visatype_name
                  : resume?.res_visatypeName
                  ? resume?.res_visatypeName
                  : "N/A"}
              </Typography>
            </Grid>
          </Grid>
        </Card>
        <Divider />
        <Card sx={{ boxShadow: "none", padding: "10px" }}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Typography
                paragraph
                sx={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: isDesktopLarge ? "14px" : "12px",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                Job Type
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography
                paragraph
                sx={{
                  margin: 0,
                  fontWeight: 500,
                  fontSize: isDesktopLarge ? "14px" : "12px",
                  color: "rgba(0,0,0,0.9)",
                }}
              >
                {resumeDetails?.jobtypeNames
                  ? resumeDetails?.jobtypeNames
                  : resume?.res_jobtypeName?.map((i) => i).join(", ")
                  ? resume?.res_jobtypeName?.map((i) => i).join(", ")
                  : "N/A"}
              </Typography>
            </Grid>
          </Grid>
        </Card>
        <Divider />

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Stack direction="row" spacing={1} sx={{ p: "4px", mt: 1 }}>
            <Button
              variant="outlined"
              sx={{ ...btnStyles, ...skillBtnStyles }}
              startIcon={
                <ManageAccountsRounded
                  sx={{ height: "16px", width: "16px", minWidth: "10px" }}
                />
              }
              onClick={() => {
                setSummaryOpen(false);
                setSkillsOpen(true);
              }}
            >
              Skills
            </Button>
            <Button
              variant="outlined"
              startIcon={
                <BusinessCenterRounded sx={{ height: "16px", width: "16px" }} />
              }
              sx={{ ...btnStyles, ...workBtnStyles }}
              onClick={() => {
                setSkillsOpen(false);
                setSummaryOpen(true);
              }}
            >
              Work
            </Button>
          </Stack>
        </Box>

        <Card sx={{ boxShadow: "none" }}>
          <CardContent>
            {skillsOpen ? (
              matchJobSkills?.length > 0 ? (
                <Card
                  sx={{
                    boxShadow: "none",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    p: isDesktopLarge ? 2 : 1,
                  }}
                >
                  <CardHeader
                    title={
                      <Typography
                        paragraph
                        style={{
                          fontSize: isDesktopLarge ? "18px" : "15px",
                          fontWeight: 400,
                          margin: 0,
                        }}
                      >
                        How{" "}
                        <span
                          style={{
                            fontWeight: 500,
                            // textDecoration: "underline",
                            color: "#e4a43c",
                          }}
                        >
                          {resume?.application_title}
                        </span>{" "}
                        match
                      </Typography>
                    }
                  />
                  <CardContent
                    sx={{
                      bgcolor: "#ffefcd",
                      // bgcolor:'#CFE4FF',
                      height: "auto",
                      maxheight: "40vh",
                      overflow: "scroll",
                      borderRadius: "6px",
                      p: 1,
                    }}
                  >
                    {matchedSkillsList?.length > 6 ? (
                      <Box
                        sx={{
                          display: "flex",
                          "&:hover": {
                            textu: {
                              textDecoration: "underline",
                              color: "blue",
                            },
                          },
                        }}
                      >
                        <WorkspacePremiumRounded
                          sx={{
                            color: "#e4a43c",
                            height: isDesktopLarge ? "36px" : "28px",
                            width: isDesktopLarge ? "36px" : "28px",
                            mr: "5px",
                          }}
                        />
                        <p
                          style={{
                            fontSize: isDesktopLarge ? "14px" : "12px",
                            margin: 0,
                          }}
                          // onClick={matchedSkills}
                          onClick={() => setMatchedSkillsOpen(true)}
                        >
                          <span
                            className={`${
                              matchedSkillsList?.length > 0 ? "match-text" : ""
                            }`}
                          >
                            {matchedSkillsList?.length} of{" "}
                            {matchJobSkills?.length > 0
                              ? matchJobSkills?.length
                              : 0}{" "}
                            skills matched it may be a good fit based on skills
                            with experience for&nbsp;
                          </span>
                          <span
                            style={{
                              background: "#e4a43c",
                              fontWeight: 500,
                              paddingInline: "7px",
                              color: "#fff",
                              borderRadius: "4px",
                              margin: 0,
                            }}
                          >
                            {resume?.application_title}
                          </span>
                        </p>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          "&:hover": {
                            ".match-text": {
                              color: "#406882",
                              textDecoration: "underline",
                              cursor: "pointer",
                            },
                          },
                        }}
                      >
                        <AssignmentLateRounded
                          sx={{
                            color: "#e4a43c",
                            height: isDesktopLarge ? "36px" : "28px",
                            width: isDesktopLarge ? "36px" : "28px",
                            mr: "5px",
                          }}
                        />
                        <Typography
                          variant="body1"
                          paragraph
                          style={{ fontSize: isDesktopLarge ? "14px" : "12px" }}
                          // onClick={matchedSkills}
                          onClick={() =>
                            matchedSkillsList?.length > 0 &&
                            setMatchedSkillsOpen(true)
                          }
                        >
                          <span
                            className={`${
                              matchedSkillsList?.length > 0 ? "match-text" : ""
                            }`}
                          >
                            {matchedSkillsList?.length} of{" "}
                            {matchJobSkills?.length > 0
                              ? matchJobSkills?.length
                              : 0}{" "}
                            skills matched based on skills with experience
                            for&nbsp;
                          </span>
                          <span
                            style={{
                              background: "#e4a43c",
                              fontWeight: 500,
                              paddingInline: "7px",
                              color: "#fff",
                              borderRadius: "4px",
                              margin: 0,
                            }}
                          >
                            {resume?.application_title}
                          </span>
                        </Typography>
                      </Box>
                    )}
                    {matchedSkillsOpen ? (
                      <List
                        sx={{
                          maxHeight: "200px",
                          overflow: "scroll",
                        }}
                      >
                        <Grid container spacing={0}>
                          {matchedSkillsList?.map((skill, index) => (
                            <Grid item xs={6} key={index}>
                              <ListItem key={index} sx={{ p: 0 }}>
                                <ArrowRightOutlined />{" "}
                                <Typography
                                  variant="body2"
                                  sx={{ fontSize: "12px" }}
                                >
                                  {skill}
                                </Typography>
                              </ListItem>
                            </Grid>
                          ))}
                        </Grid>
                      </List>
                    ) : null}
                  </CardContent>
                  <CardContent sx={{ p: 0, mt: 1 }}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TableContainer
                          component={Paper}
                          sx={{ maxHeight: 400 }}
                        >
                          <Table
                            aria-label="customized table"
                            stickyHeader
                            size="small"
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell>Resume Skills</StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {skillsInResume?.map((row, index) => (
                                <StyledTableRow key={index}>
                                  <StyledTableCell component="th" scope="row">
                                    {row}
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                      <Grid item xs={6}>
                        <TableContainer
                          component={Paper}
                          sx={{ maxHeight: 400 }}
                        >
                          <Table
                            aria-label="customized table"
                            stickyHeader
                            size="small"
                          >
                            <TableHead>
                              <TableRow>
                                <StyledTableCell>
                                  Required Skills
                                </StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {matchJobSkills?.map((row, index) => (
                                <StyledTableRow key={index}>
                                  <StyledTableCell component="th" scope="row">
                                    {row}
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ) : (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <TableContainer
                    component={Paper}
                    sx={{ maxHeight: 400, maxWidth: "400px" }}
                  >
                    <Table
                      aria-label="customized table"
                      stickyHeader
                      size="small"
                    >
                      <TableHead>
                        <TableRow>
                          <StyledTableCell
                            colSpan={2}
                            sx={{ textAlign: "center" }}
                          >
                            Resume Skills
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {matchResumeSkills.length > 0 ? (
                          matchResumeSkills.map((row, index) => {
                            if (index % 2 === 0) {
                              return (
                                <StyledTableRow key={index}>
                                  <TableCell
                                    sx={{
                                      fontSize: isDesktopLarge
                                        ? "14px"
                                        : "12px",
                                    }}
                                  >
                                    {row}
                                  </TableCell>
                                  {matchResumeSkills[index + 1] && (
                                    <TableCell
                                      sx={{
                                        fontSize: isDesktopLarge
                                          ? "14px"
                                          : "12px",
                                      }}
                                    >
                                      {matchResumeSkills[index + 1]}
                                    </TableCell>
                                  )}
                                </StyledTableRow>
                              );
                            }
                            return null;
                          })
                        ) : (
                          <Typography
                            paragraph
                            sx={{
                              margin: 0,
                              paddingTop: 2,
                              textAlign: "center",
                            }}
                          >
                            Skills Not found
                          </Typography>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )
            ) : summaryOpen ? (
              <>
                <Card sx={{ border: "1px solid #ddd" }}>
                  <CardHeader
                    title={
                      <Typography
                        paragraph
                        style={{
                          fontSize: isDesktopLarge ? "18px" : "15px",
                          fontWeight: 500,
                          margin: 0,
                        }}
                      >
                        Experience
                      </Typography>
                    }
                    sx={{ borderBottom: "1px solid #ddd" }}
                  />
                  <CardContent>
                    {resumeFullDetails &&
                      resumeFullDetails.map((data, index) => (
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{
                            bgcolor: "background.paper",
                            color: "text.secondary",
                            "& svg": {
                              m: 1.5,
                            },
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            p: 1,
                            mb: 1,
                          }}
                          key={index}
                        >
                          <Avatar
                            sx={{
                              height: isDesktopLarge ? "50px" : "40px",
                              width: isDesktopLarge ? "50px" : "40px",
                            }}
                          >
                            <LocationCityOutlined
                              sx={{
                                height: isDesktopLarge ? "32px" : "26px",
                                width: isDesktopLarge ? "32px" : "26px",
                              }}
                            />
                          </Avatar>
                          <Box>
                            <Typography
                              variant="body2"
                              component="p"
                              // variant="subtitle1"
                              fontWeight={500}
                              sx={{
                                margin: 0,
                                fontSize: isDesktopLarge ? "1.0rem" : "0.85rem",
                                color: "rgba(0,0,0,0.8)",
                                lineHeight: 1.5,
                              }}
                            >
                              {data?.pro_role}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Breadcrumbs
                                separator="-"
                                aria-label="breadcrumb"
                              >
                                <Typography
                                  variant="body2"
                                  component="p"
                                  sx={{
                                    fontSize: isDesktopLarge
                                      ? "1.0rem"
                                      : "0.85rem",
                                    lineHeight: 1.42,
                                    color: "rgba(0,0,0,0.6)",
                                  }}
                                >
                                  {data?.pro_client}
                                </Typography>
                                {/* <Typography
                                 variant="body2"
                                 component="p"
                                 sx={{
                                   fontSize: "1rem",
                                   lineHeight: 1.42,
                                   color: "rgba(0,0,0,0.6)",
                                 }}
                               >
                                 Full Time
                               </Typography> */}
                              </Breadcrumbs>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Breadcrumbs
                                separator={<Bullet />}
                                aria-label="breadcrumb"
                              >
                                <Typography
                                  variant="body2"
                                  component="p"
                                  sx={{
                                    fontSize: isDesktopLarge
                                      ? "0.85rem"
                                      : "0.75rem",
                                    color: "rgba(0,0,0,0.5)",
                                  }}
                                >
                                  {moment(data?.pro_startdate).format("ll")} -{" "}
                                  {moment(data?.pro_enddate).format("ll") ==
                                  "Invalid date"
                                    ? "Till Date"
                                    : moment(data?.pro_enddate).format("ll")}
                                </Typography>
                                {/* <Typography
                                 variant="body2"
                                 component="p"
                                 sx={{ fontSize: "14px", color: "rgba(0,0,0,0.5)" }}
                               >
                                 2 yrs 5 mos
                                 {moment.duration(moment(data?.pro_enddate).diff(moment(data?.pro_startdate)))}
                               </Typography> */}
                              </Breadcrumbs>
                            </Box>
                            <Typography
                              variant="body2"
                              component="p"
                              sx={{
                                fontSize: isDesktopLarge
                                  ? "0.85rem"
                                  : "0.75rem",
                                color: "rgba(0,0,0,0.5)",
                              }}
                            >
                              {data?.cityname !== null &&
                              data?.statename !== null
                                ? `${data?.cityname}, ${data?.statename}, ${data?.shortRegion}`
                                : "Remote"}
                            </Typography>
                          </Box>
                        </Stack>
                      ))}
                  </CardContent>
                </Card>
                <Card sx={{ border: "1px solid #ddd", mt: 2 }}>
                  <CardHeader
                    title={
                      <Typography
                        paragraph
                        style={{
                          fontSize: isDesktopLarge ? "18px" : "15px",
                          fontWeight: 500,
                          margin: 0,
                        }}
                      >
                        Certifications
                      </Typography>
                    }
                    sx={{ borderBottom: "1px solid #ddd" }}
                  />
                  <CardContent>
                    {resumeCertificationDetails?.length > 0 ? (
                      <Stack direction="column">
                        {resumeCertificationDetails.map((cer, index) => (
                          <Typography
                            paragraph
                            key={index}
                            sx={{
                              m: 0,
                              fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                            }}
                          >
                            {`${index + 1}. `}
                            {cer.cer_name}
                          </Typography>
                        ))}
                      </Stack>
                    ) : (
                      <Card>No Certifications</Card>
                    )}
                  </CardContent>
                </Card>
              </>
            ) : (
              <></>
            )}
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default ResumeDetails;

const btnStyles = {
  borderRadius: "25px",
  padding: "0px 15px 0px 15px",
  textTransform: "capitalize",
  border: "1px solid #ddd",
  color: "rgba(0,0,0,0.6)",
  "&:hover": {
    bgcolor: "#406882",
    color: "#fff",
    border: "1px solid #406882",
  },
};
